import { Component, OnInit } from '@angular/core';
import { Usuario } from './usuarios.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { getCurrentLanguage } from '../core/helpers/utils';
import { generalTranslations } from '../core/helpers/translations';

// services
import { EventService } from 'src/app/core/service/event.service';
import { UsuarioService } from './usuarios.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-detail-usuario',
  templateUrl: './detail-usuario.component.html',
  styleUrls: ['./detail-usuario.component.scss']
})
export class DetailUsuarioComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) { }

  // Declaro el array empleado para rellenarlo en el Oninit y usarlo con el 2-way data binding
  usuario = <Usuario>{};

  // ID del usuario
  id!: string | null;

   // Avatar con url sergura
   avatarUrl?: SafeUrl;

  model = {
    nombre: '',
    apellidos: '',
    email: '',
    telefono: '',
    nivel_acceso: '',
  }

  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;    
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.EDITAR_USUARIO,
        breadCrumbItems: [{ label: currentTranslations.USUARIOS, path: '.' }, { label: currentTranslations.EDITAR_USUARIO, path: '.', active: true }]
      }
    );

    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id !== null) {
      this.usuarioService.getUsuario(this.id).subscribe(resUsuario => {
        this.usuario = resUsuario;

        this.usuarioService.getAvatar(resUsuario.id).subscribe(avatarBlob => {
          if (avatarBlob) {
            const blobUrl = URL.createObjectURL(avatarBlob);
            this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
          }
        });
      })
    }

  }

  onSubmit(form: NgForm) {
    const usuario: Usuario = {
      nombre: form.value.nombre,
      apellidos: form.value.apellidos,
      email: form.value.email,
      telefono: form.value.telefono,
      nivel_acceso: this.usuario.es_representante ? 'USUARIO' : form.value.nivel_acceso // Ajustar el valor según la condición
    }
  
    if (this.id !== null) {
      this.usuarioService.updateUsuario(this.id, usuario)
        .subscribe(res => {
          window.location.reload();
        });
    }
  }
  

  uploadAvatar(id: string, avatar: File) {
    if (id) {
      //this.isSaving = true;      
      const formData = new FormData();
      formData.append('foto', avatar);

      this.usuarioService.updateAvatar(id, formData).subscribe({
        next: () => {
          //this.mostrarMensajeGuardado()
          //this.error = '';
          this.refreshAvatar(id);
          this.eventService.broadcast(EventType.UPDATE_AVATAR, { userId: id });
          //console.log("Avatar enviado al back->", formData);
        },
        error: (error: any) => {
          //console.error("Error al guardar árbitro: ", error, id, formData);
          //this.error = error;
          //this.isSaving = false;
        }
      });
    }
  }

  // Se ejecuta cuando hace el value Change en el input de la foto
  onFileChange(event: Event) {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const avatar = input.files[0];
        this.uploadAvatar(id, avatar);
      }
    }

  }

  // Se llama desde el botón para cambiar foto
  triggerFileInput() {
    // Accede al elemento input usando document.getElementById y dispara el clic
    const fileInput = document.getElementById('inputAvatar') as HTMLInputElement;
    fileInput.click();
  }

  refreshAvatar(id: string){
    this.usuarioService.getAvatar(id).subscribe(avatarBlob => {
      if (avatarBlob) {
        const blobUrl = URL.createObjectURL(avatarBlob);
        this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
      }
    });
  }

}
